module.exports = __webpack_public_path__ + "572e1d2c1c145b2266b0b520ef4c15e4.png";